import { render, staticRenderFns } from "./alertMessageDetailLog.vue?vue&type=template&id=67921ea8&scoped=true&"
import script from "./alertMessageDetailLog.vue?vue&type=script&lang=js&"
export * from "./alertMessageDetailLog.vue?vue&type=script&lang=js&"
import style0 from "./alertMessageDetailLog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./alertMessageDetailLog.vue?vue&type=style&index=1&id=67921ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67921ea8",
  null
  
)

export default component.exports